import type { FaireProductEntity } from "../../entity_types/product";

export const p_46f6dh3us9: FaireProductEntity = {
  token: "p_46f6dh3us9",
  type: "product",
  name: "Money Herbal Intention Candles",
  brandToken: "b_p4a82gaf2t",
  brandName: "Elemental Earth Shop",
  imageUrl:
    "https://cdn.faire.com/fastly/5e88dafa44a26b9285a6ebb222aa7312fa4cadba38e70bf28ef7640d345406f4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/594518c0b407ceae3a9c9014aedb5d8d68ac1e69bd9ed53955bcaabf0ab1f12e.jpeg",
    "https://cdn.faire.com/fastly/e2ee5fc0e286f8590d3dce8fd37535ef08f12f116082a8a835500cbb12afe7e9.jpeg",
    "https://cdn.faire.com/fastly/afc740de9ce3cf9530061c0de1b411b8644c08d2c0a00acf6c6712cbda0ae005.jpeg",
  ],
  priceDollars: 8,
  description:
    "Bring money and abundance into your life with Money intention candles. Candles created with a blend of natural herbs and essential oils. Designed with love and intention.\n\n• 5 hours burn time under ideal conditions.\n• Strongly Scented: Frasier fir, color may vary.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:02.022Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
